import { GENERAL_CONSTANTS } from "@/shared/constants/GeneralConstants";
import {
  SNACKBAR_STYLE,
  WARNING_TEXT_COLOR
} from "@/shared/constants/StyleConstants";
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  name: "WarningDeleteMessage"
})
export default class WarningDeleteMessage extends Vue {
  @Prop({ default: "" }) private message!: string;

  WARNING_DELETED_MESSAGE = GENERAL_CONSTANTS.TEXTS.WARNING_DELETED_MESSAGE;
  WARNING_TITLE = GENERAL_CONSTANTS.TEXTS.WARNING;
  WARNING_COLOR = SNACKBAR_STYLE.WARNING.COLOR;
  WARNING_ICON = SNACKBAR_STYLE.WARNING.ICON;
  WARNING_TEXT_COLOR = WARNING_TEXT_COLOR;

  mounted() {
    if (this.message) {
      this.WARNING_DELETED_MESSAGE = this.message;
    }
  }
}
